import type { HostInfo } from '~/use-cases/types/HostInfo';
import { SiteRoute } from '~/use-cases/types/SiteRoute';
import { MagicUseCase } from '../magicUseCase';
import { LoadCompanyInfoUseCase } from './loadCompanyInfoUseCase';

export interface OpenCompanySiteRequest {
  host: HostInfo;
  pageUrl?: string;
  isDev: boolean;
}

export class OpenCompanySiteUseCase extends MagicUseCase<OpenCompanySiteRequest> {
  protected async runLogic({ host, pageUrl, isDev }: OpenCompanySiteRequest) {
    await new LoadCompanyInfoUseCase().execute(host);
    const { domain, companyInfo, isCompanyNotFound } = this.getState().user;
    const url = pageUrl ? new URL(pageUrl) : undefined;
    if (isCompanyNotFound) {
      if (url?.pathname !== SiteRoute.CompanyNotFound) {
        this.navigate(SiteRoute.CompanyNotFound);
      }
      return;
    }
    const customDomain = companyInfo?.customDomain;
    if (isDev || !url || !customDomain || domain === customDomain) {
      return;
    }
    url.hostname = customDomain;
    url.protocol = 'https:';
    url.port = '';
    this.navigate(url.toString());
  }
}
